import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import Paper from "@mui/material/Paper";

import moment from "moment";
import { useNavigate } from "react-router-dom";
import { TableFooter } from "@mui/material";

function TablePaginationActions(props) {
   const theme = useTheme();
   const { count, page, rowsPerPage, onPageChange } = props;

   const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
   };

   const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
   };

   const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
   };

   const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
   };

   return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
         <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
         >
            {theme?.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
         </IconButton>
         <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="previous page"
         >
            {theme?.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
         </IconButton>
         <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
         >
            {theme?.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
         </IconButton>
         <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
         >
            {theme?.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
         </IconButton>
      </Box>
   );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
   [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#007BFF",
      color: theme.palette.common.white,
   },
   [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
   },
}));

const TripTable = ({ rows, limit = 0, page = 0, setPage, setLimit, listPagination }) => {
   const navigate = useNavigate();

   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event) => {
      setLimit(parseInt(event.target.value, 10));
      setPage(0);
   };

   // Avoid a layout jump when reaching the last page with empty rows.

   return (
      <Box sx={{ width: "100%" }}>
         <Paper sx={{ width: "100%", mb: 2 }}>
            {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
            <TableContainer>
               <Table
                  sx={{ minWidth: 750, border: "2px solid #007BFF" }}
                  aria-labelledby="tableTitle"
                  //   size={dense ? "small" : "medium"}

                  size="small"
               >
                  <TableHead>
                     <TableRow>
                        <StyledTableCell align="left">Vehicle Number</StyledTableCell>
                        <StyledTableCell align="left">Driver Name</StyledTableCell>
                        <StyledTableCell align="left">Created By</StyledTableCell>
                        <StyledTableCell align="left">Customer Name</StyledTableCell>
                        <StyledTableCell align="left">Start Date</StyledTableCell>
                        <StyledTableCell align="left">Dispatch Date</StyledTableCell>
                        <StyledTableCell align="left">Trip Status</StyledTableCell>
                        <StyledTableCell align="left">Review Status</StyledTableCell>
                        <StyledTableCell align="right">Action</StyledTableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {rows.map((row) => {
                        return (
                           <TableRow key={row.tripid}>
                              <TableCell component="th" align="left">
                                 {row?.fleet_master?.vehicle_no}
                              </TableCell>
                              <TableCell align="left">
                                 {row?.driver_master?.name}
                              </TableCell>
                              <TableCell align="left">{row?.created_by?.name}</TableCell>
                              <TableCell align="left">{row.customername}</TableCell>
                              <TableCell align="left">
                                 {row?.created_at
                                    ? moment(row?.created_at).format("YYYY-MM-DD, h:mm a")
                                    : "-"}
                              </TableCell>
                              <TableCell align="left">
                                 {row.vehicle_disptch_date}
                              </TableCell>
                              <TableCell align="left">
                                 <span
                                    className={`text-${
                                       row?.trip_status === "open"
                                          ? "success"
                                          : row?.trip_status === "closed"
                                          ? "danger"
                                          : "warning"
                                    } mx-2 text-uppercase font-weight-bold`}
                                 >
                                    {row?.trip_status}
                                 </span>
                              </TableCell>
                              <TableCell align="left">
                                 <span
                                    className={`text-${
                                       row?.review_status === "pending"
                                          ? "warning"
                                          : row?.review_status === "rejected"
                                          ? "danger"
                                          : row?.review_status === "approved"
                                          ? "success"
                                          : ""
                                    } mx-2 text-uppercase font-weight-bold`}
                                 >
                                    {row?.review_status}
                                 </span>
                              </TableCell>
                              <TableCell align="right">
                                 {" "}
                                 <button
                                    className="btn btn-primary "
                                    onClick={() =>
                                       navigate("/trip/adhoc/edit/" + row.id)
                                    }
                                 >
                                    View
                                 </button>
                              </TableCell>
                           </TableRow>
                        );
                     })}
                  </TableBody>
                  <TableFooter sx={{ border: "2px solid #007BFF" }}>
                     <TableRow>
                        <TablePagination
                           rowsPerPageOptions={[5, 10, 25]}
                           // colSpan={3}
                           count={listPagination?.total || 0}
                           rowsPerPage={limit}
                           page={page}
                           slotProps={{
                              select: {
                                 inputProps: {
                                    "aria-label": "rows per page",
                                 },
                                 native: true,
                              },
                           }}
                           onPageChange={handleChangePage}
                           onRowsPerPageChange={handleChangeRowsPerPage}
                           ActionsComponent={TablePaginationActions}
                        />
                     </TableRow>
                  </TableFooter>
               </Table>
            </TableContainer>
         </Paper>
      </Box>
   );
};

export default TripTable;
